let idIndex = 0;

export default function useUniqueId(prefix = 'id'): string {
  idIndex += 1;
  return `${prefix}-${idIndex}`;
}
